export default "__VITE_ASSET__DKUnf8jB__"